import Constants from "expo-constants";

export type ArticleId =
    | "CreateMissionEarningType.time_sheets"
    | "SalaryProjection"
    | "InvoicedSalary"
    | "IJMGroupClient"
    | "IJMGroupWorker"
    | "IJMTalentProfile"
    | "LegalEmployerInfo"
    | "WorkingTimeTypes";

/**
 * Indirection to match key to article ID in Intercom
 */
const ARTICLES: Record<ArticleId | "default", string> = {
    "CreateMissionEarningType.time_sheets": "8708309",
    SalaryProjection: "9319123",
    InvoicedSalary: "8811204",
    IJMGroupClient: "10430244",
    IJMGroupWorker: "10436709",
    IJMTalentProfile: "10721947",
    LegalEmployerInfo: "11018443",
    WorkingTimeTypes: "11051899",
    default: "8717817",
};

export const getArticleId = (articleId: ArticleId): string => {
    return ARTICLES[articleId] || ARTICLES.default;
};

export const isIntercomEnabled = (): boolean => {
    return !!Constants.expoConfig?.extra?.intercomAppId;
};
